import { DFSValueType, FormDefinitionWrapper, NIImageData } from './services/form';
import React, { Context, createContext, useState } from 'react';
import { Observable } from 'rxjs';
import { ExpressionManager } from './services/ExpressionManager';
import { ValidityManager } from './services/ValidityManager';
import { VisibilityManager } from './services/VisibilityManager';

export interface ImageService {
  getImageData: (ids: string[]) => Observable<NIImageData[]>;
  downloadImage: (id: string) => Observable<NIImageData>;
}

export interface IFormContext {
  form: FormDefinitionWrapper;
  expMgr: ExpressionManager | null;
  visibilityMgr: VisibilityManager | null;
  validityMgr: ValidityManager | null;
  onSetData: (path: string, scope: string, newData: DFSValueType) => void;
  onRemoveData: (path: string, scope: string) => void;
  scope: string;
  evalID?: string;
  isDeskAudit: boolean;
  toggleDeskAudit: () => void;
  isFocusedAudit: boolean;
  toggleFocusedAudit: () => void;
  imageService: ImageService | null;
  isReadonly: boolean,
  setIsReadonly: (isReadonly: boolean) => void;
}

export const FormContext: Context<IFormContext> = createContext({
  form: {} as FormDefinitionWrapper,
  expMgr: null,
  visibilityMgr: null,
  validityMgr: null,
  onSetData() {},
  onRemoveData() {},
  scope: '',
  isDeskAudit: false,
  toggleDeskAudit() {},
  isFocusedAudit: false,
  toggleFocusedAudit() {},
  imageService: null,
  isReadonly: false,
  setIsReadonly() {}
} as IFormContext);


export const FormProvider = ({ children }: { children: any }) => {
  
  const [isDeskAudit, setIsDeskAudit] = useState(false);
  const [isFocusedAudit, setIsFocusedAudit] = useState(false);
  const [isReadonly, setIsReadonly] = useState(false);

  const toggleDeskAudit = () => {
    setIsDeskAudit(!isDeskAudit);
  };

  const toggleFocusedAudit = () => {
    setIsFocusedAudit(!isFocusedAudit);
  };

  return <FormContext.Provider
    value={{ 
        form: {} as FormDefinitionWrapper,
        expMgr: null,
        visibilityMgr: null,
        validityMgr: null,
        onSetData() {},
        onRemoveData() {},
        scope: '',
        isDeskAudit,
        toggleDeskAudit,
        isFocusedAudit,
        toggleFocusedAudit,
        imageService: null,
        isReadonly,
        setIsReadonly
      }
    }>
  </FormContext.Provider>
}